import React, {useContext} from 'react';
import Context from '../OriginStoryProvider';

const ParagraphsSection = () => {
	const { data: {content} } = useContext(Context);

	return (
		<div className='chapter-2__paragraphs main-grid'>
			<div className='main-grid__margin'></div>
			<div className='main-grid__body'>
				<p className='chapter-2__paragraphs__title'>
					{content.chapters.second.paragraphs_section.title}
				</p>
				<div className='chapter-2__paragraphs__container'>
					<p className='chapter-2__paragraphs__text' 						dangerouslySetInnerHTML={{__html: content.chapters.second.paragraphs_section.paragraph_1}}
					>
					</p>
					<p className='chapter-2__paragraphs__text' dangerouslySetInnerHTML={{__html: content.chapters.second.paragraphs_section.paragraph_2}}>
					</p>
				</div>
			</div>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default ParagraphsSection;